import { render, staticRenderFns } from "./InvoiceDetailsModal.vue?vue&type=template&id=1a874fd6&scoped=true"
import script from "./InvoiceDetailsModal.vue?vue&type=script&lang=js"
export * from "./InvoiceDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./InvoiceDetailsModal.vue?vue&type=style&index=0&id=1a874fd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a874fd6",
  null
  
)

export default component.exports